export const REWARDS_ROUTE = 'rewards';
